import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import React from 'react';

import SliderIcon from '../../../../assets/icons/stimulation-slider.svg?react';
import { themes } from 'kb-shared';
import styled from 'styled-components';

import Indicator from '../Indicator';

const Container = styled.div`
  padding: 20px 10px;
  padding-top: 70px;

  .rc-slider-mark-text {
    display: none;
  }
`;

const SliderContainer = styled.div`
  margin-top: -18px;
  margin-left: -11px;
`;

const IndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
`;

const IndicatorPosition = styled.div`
  position: absolute;
  top: -70px;
  left: -45px;
`;

type Props = {
  onValueChange: (value: number) => void;
  validSteps: Array<number>;
  currentValue: number;
  maxValue: number;
};

export const CustomSlider = (props: Props) => {
  // Generate marks so that slider snaps into locations where valid steps are
  const marks = props.validSteps.reduce(
    (map, value) => {
      map[value] = String(value);
      return map;
    },
    {} as Record<number, string>
  );
  const initialSliderPosition = props.validSteps[props.validSteps.length - 1];

  return (
    <Container>
      <Slider
        marks={marks}
        dotStyle={{ opacity: 0 }}
        step={null}
        min={props.validSteps[0]}
        max={props.validSteps[props.validSteps.length - 1]}
        defaultValue={initialSliderPosition}
        handleRender={(origin, handleProps) => {
          return React.cloneElement(origin, {
            children: (
              <SliderContainer>
                <SliderIcon />
                <IndicatorPosition>
                  <IndicatorContainer>
                    <Indicator text={`Day ${handleProps.value + 1}`} icons={[]} />
                  </IndicatorContainer>
                </IndicatorPosition>
              </SliderContainer>
            )
          });
        }}
        trackStyle={[{ backgroundColor: themes.colors.neutral.lavender, height: 10 }]}
        railStyle={{ backgroundColor: themes.colors.neutral.primaryNavy, height: 10 }}
        onChange={(value: number | number[]) => {
          if (Array.isArray(value)) {
            props.onValueChange(value[0]);
            return;
          }
          props.onValueChange(value);
        }}
      />
    </Container>
  );
};
